import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import WebsiteLayout from "@/layouts/WebsiteLayout.vue";
import AdminLayout from "@/layouts/AdminLayout.vue";
import AppLayout from "@/layouts/AppLayout.vue";
import PrintLayout from "@/layouts/PrintLayout.vue";

import RetrieveUserLogin from "@/core/services/RetrieveUserLogin.vue";
import RetrieveUsername from "@/core/services/RetrieveUsername.vue";
import RetrievedUserLogin from "@/core/services/RetrievedUserLogin.vue";
import Authenticator from "@/core/services/Authenticator.vue";
import AssessmentPrinter from "@/components/global-components/AssessmentPrinter.vue";
import LessonPrinter from "@/components/global-components/LessonPrinter.vue";

import AppLandingView from "@/views/app/AppLandingView.vue";
import AppProfileView from "@/views/app/AppProfileView.vue";
import AppPurchaseConfirmationView from "@/views/app/AppPurchaseConfirmationView.vue";
import AppProductOrdersView from "@/views/app/AppProductOrdersView.vue";
import AppCalendarView from "@/views/app/AppCalendarView.vue";
import AppPlannerView from "@/views/app/AppPlannerView.vue";
import AppContactSupportView from "@/views/app/AppContactSupportView.vue";
import AppSubjectTemplatesView from "@/views/app/AppSubjectTemplatesView.vue";
import AppAssessmentsView from "@/views/app/AppAssessmentsView.vue";
import AppProductsView from "@/views/app/AppProductsView.vue";
import AppCommunicationsView from "@/views/app/AppCommunicationsView.vue";

import AdminLandingView from "@/views/admin/AdminLandingView.vue";
import AdminReportingView from "@/views/admin/AdminReportingView.vue";
import AdminSubjectsView from "@/views/admin/AdminSubjectsView.vue";
import AdminHolidaysView from "@/views/admin/AdminHolidaysView.vue";
import AdminProductsView from "@/views/admin/AdminProductsView.vue";
import AdminProductBundlesView from "@/views/admin/AdminProductBundlesView.vue";
import AdminProductOrdersView from "@/views/admin/AdminProductOrdersView.vue";
import AdminProductOrderQuotesView from "@/views/admin/AdminProductOrderQuotesView.vue";
import AdminTermsView from "@/views/admin/AdminTermsView.vue";
import AdminSchoolsView from "@/views/admin/AdminSchoolsView.vue";
import AdminTaxonomiesView from "@/views/admin/AdminTaxonomiesView.vue";
import AdminSubjectTemplatesView from "@/views/admin/AdminSubjectTemplatesView.vue";
import AdminAssessmentTemplatesView from "@/views/admin/AdminAssessmentTemplatesView.vue";
import AdminAnnouncementsView from "@/views/admin/AdminAnnouncementsView.vue";
import AdminCouponsView from "@/views/admin/AdminCouponsView.vue";
import AdminCommunicationsView from "@/views/admin/AdminCommunicationsView.vue";
import AdminCustomersView from "@/views/admin/AdminCustomersView.vue";
// import AdminTeacherProfilesView from "@/views/admin/AdminTeacherProfilesView.vue";

import WebsiteLandingView from "@/views/website/WebsiteLandingView.vue";
import WebsiteProductView from "@/views/website/WebsiteProductView.vue";
import WebsiteAboutView from "@/views/website/AboutView.vue";
import WebsiteTermsView from "@/views/website/TermsView.vue";
// import WebsitePricesView from "@/views/website/PricesView.vue";
//import WebsiteHowItWorksView from "@/views/website/HowItWorksView.vue";
import WebsiteContactUsView from "@/views/website/ContactUsView.vue";
import WebsiteQuoteRequestView from "@/views/website/QuoteRequestView.vue";
import WebsiteGuestProductContentDownloaderView from "@/views/website/GuestProductContentDownloaderView.vue";
import WebsiteMeetTheTeamView from "@/views/website/MeetTheTeam.vue";

// import DevTestView from '@/views/website/DevTestView.vue';

import PageNotFoundView from "@/views/PageNotFoundView.vue";
// import NotSubscribedView from "@/views/NotSubscribedView.vue";

import {
  Auth,
  // , API
} from "aws-amplify";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "WebsiteLanding",
    component: WebsiteLandingView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteLanding" },
  },
  {
    path: "/just-bought-product/:productId",
    name: "WebsiteJustBoughtProduct",
    component: WebsiteLandingView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteJustBoughtProduct" },
  },
  {
    path: "/product/*",
    name: "WebsiteProduct",
    component: WebsiteProductView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteProduct" },
  },
  {
    path: "/category/:categoryId*",
    name: "WebsiteLandingCategory",
    component: WebsiteLandingView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteLandingCategory" },
  },
  {
    path: "/cart",
    name: "WebsiteCart",
    component: WebsiteLandingView,
    meta: {
      layout: WebsiteLayout,
      gtm: "WebsiteLandingCart",
    },
  },
  {
    path: "/checkout",
    name: "WebsiteCheckout",
    component: WebsiteLandingView,
    meta: {
      layout: WebsiteLayout,
      gtm: "WebsiteLandingCheckout",
    },
  },
  {
    path: "/purchase-confirmation/:orderId",
    name: "PurchaseConfirmation",
    component: AppPurchaseConfirmationView,
    meta: {
      layout: AppLayout,
      // requiresAuth: true,
      // allowedGroups: ["teacher"],
      gtm: "PurchaseConfirmation",
    },
  },
  {
    path: "/admin",
    name: "AdminLanding",
    component: AdminLandingView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["superadmin"],
      gtm: "AdminLanding",
      noTrack: true,
    },
  },
  {
    path: "/admin/reporting/:report",
    name: "AdminReporting",
    component: AdminReportingView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["reporting"],
      gtm: "AdminReporting",
      noTrack: true,
    },
  },
  {
    path: "/admin/subjects",
    name: "AdminSubjects",
    component: AdminSubjectsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminSubjects",
      noTrack: true,
    },
  },
  {
    path: "/admin/holidays",
    name: "AdminHolidays",
    component: AdminHolidaysView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminHolidays",
      noTrack: true,
    },
  },
  // {
  //   path: "/admin/customers",
  //   name: "AdminCustomers",
  //   component: AdminCustomersView,
  //   meta: {
  //     layout: AdminLayout,
  //     requiresAuth: true,
  //     allowedGroups: ["admin", "superadmin"],
  //   },
  // },
  {
    path: "/admin/teacherprofiles",
    name: "AdminTeacherProfiles",
    // component: AdminTeacherProfilesView,
    component: AdminCustomersView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin", "superadmin"],
      gtm: "AdminTeacherProfiles",
      noTrack: true,
    },
  },
  {
    path: "/admin/products",
    name: "AdminProducts",
    component: AdminProductsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProducts",
      noTrack: true,
    },
  },
  {
    path: "/admin/productbundles",
    name: "AdminProductBundles",
    component: AdminProductBundlesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProductBundles",
      noTrack: true,
    },
  },
  {
    path: "/admin/productorder-quotes/customer/:teacherProfileId/:owner/:action*",
    name: "AdminCustomerProductOrderQuotes",
    component: AdminProductOrderQuotesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCustomerProductOrderQuotes",
      noTrack: true,
    },
  },
  {
    path: "/admin/productorder-quotes/:orderId*",
    name: "AdminProductOrderQuotes",
    component: AdminProductOrderQuotesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProductOrderQuotes",
      noTrack: true,
    },
  },
  {
    path: "/admin/productorders/customer/:teacherProfileId/:owner/:action*",
    name: "AdminCustomerProductOrders",
    component: AdminProductOrdersView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCustomerProductOrders",
      noTrack: true,
    },
  },
  {
    path: "/admin/productorders/:orderId*",
    name: "AdminProductOrders",
    component: AdminProductOrdersView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProductOrders",
      noTrack: false,
    },
  },
  {
    path: "/admin/lessontemplates",
    name: "AdminSubjectTemplates",
    component: AdminSubjectTemplatesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminSubjectTemplates",
      noTrack: true,
    },
  },
  {
    path: "/admin/assessmenttemplates",
    name: "AdminAssessmentTemplates",
    component: AdminAssessmentTemplatesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminAssessmentTemplates",
      noTrack: true,
    },
  },
  {
    path: "/admin/terms",
    name: "AdminTerms",
    component: AdminTermsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminTerms",
      noTrack: true,
    },
  },
  {
    path: "/admin/schools",
    name: "AdminSchools",
    component: AdminSchoolsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminSchools",
      noTrack: true,
    },
  },
  {
    path: "/admin/taxonomies",
    name: "AdminTaxonomies",
    component: AdminTaxonomiesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminTaxonomies",
      noTrack: true,
    },
  },
  {
    path: "/admin/announcements",
    name: "AdminAnnouncements",
    component: AdminAnnouncementsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminAnnouncements",
      noTrack: true,
    },
  },
  {
    path: "/admin/coupons",
    name: "AdminCoupons",
    component: AdminCouponsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCoupons",
      noTrack: true,
    },
  },
  {
    path: "/admin/communications/:channel*",
    name: "AdminCommunications",
    component: AdminCommunicationsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCommunications",
      noTrack: true,
    },
  },
  {
    path: "/app",
    name: "AppLanding",
    component: AppLandingView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppLanding",
    },
  },
  {
    path: "/app/profile",
    name: "AppProfile",
    component: AppProfileView,
    meta: { layout: AppLayout, requiresAuth: true, gtm: "AppProfile" },
  },
  {
    path: "/app/communications/:channel*",
    name: "AppCommunications",
    component: AppCommunicationsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppCommunications",
      allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/productorders/:orderId*",
    name: "AppProductOrders",
    component: AppProductOrdersView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProductOrders",
      allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/calendar",
    name: "AppCalendar",
    component: AppCalendarView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppCalendar",
    },
  },
  {
    path: "/app/lessonplanning",
    name: "AppPlanner",
    component: AppPlannerView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppPlanner",
    },
  },
  {
    path: "/app/support",
    name: "AppSupport",
    component: AppContactSupportView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppSupport",
      allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/lessons",
    name: "AppLessons",
    component: AppSubjectTemplatesView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppLessons",
    },
  },
  {
    path: "/app/assessments",
    name: "AppAssessments",
    component: AppAssessmentsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppAssessments",
    },
  },
  {
    path: "/app/products/category/:categoryId*",
    name: "AppProductsCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProductsCategory",
      // allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/products/:productId/:action*",
    name: "AppProductsAction",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProductsAction",
      // allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/products/:productId*",
    name: "AppProducts",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProducts",
      // allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/purchased-resources/category/:categoryId*",
    name: "AppPurchasedResourcesCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppPurchasedResourcesCategory",
    },
  },
  {
    path: "/app/purchased-resources",
    name: "AppPurchasedResources",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppPurchasedResources",
    },
  },
  {
    path: "/app/purchased-resources/:productId*",
    name: "AppPurchasedResourcesProduct",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppPurchasedResourcesProduct",
      allowedGroups: ["teacher"],
    },
  },
  {
  path: "/app/school-resources",
  name: "SchoolResources",
  component: AppProductsView,
  meta: { layout: AppLayout, requiresAuth: true },
},
{
  path: "/app/school-resources/category/:categoryId",
  name: "SchoolResourcesCategory",
  component: AppProductsView,
  meta: { layout: AppLayout, requiresAuth: true },
},
  {
    path: "/app/subscribed-products/category/:categoryId*",
    name: "AppSubscribedProductsCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppSubscribedProductsCategory",
    },
  },
  {
    path: "/app/subscribed-products",
    name: "AppSubscribedProducts",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppSubscribedProducts",
    },
  },
  {
    path: "/app/bought-products/category/:categoryId*",
    name: "AppBoughtProductsCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppBoughtProductsCategory",
      // allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/bought-products",
    name: "AppBoughtProducts",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppBoughtProducts",
      // allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/print/assessment/:templateId",
    name: "AppAssessmentPrinter",
    component: AssessmentPrinter,
    meta: {
      layout: PrintLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppAssessmentPrinter",
    },
  },
  {
    path: "/app/print/lesson/:templateId",
    name: "AppLessonPrinter",
    component: LessonPrinter,
    meta: {
      layout: PrintLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppLessonPrinter",
    },
  },
  {
    path: "/about",
    name: "WebsiteAbout",
    component: WebsiteAboutView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteAbout" },
  },
  {
    path: "/terms",
    name: "WebsiteTerms",
    component: WebsiteTermsView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteTerms" },
  },
  {
    path: "/contact-us",
    name: "WebsiteContactUs",
    component: WebsiteContactUsView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteContactUs" },
  },
  {
    path: "/request-a-quote",
    name: "WebsiteQuoteRequest",
    component: WebsiteQuoteRequestView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteQuoteRequest" },
  },
  {
    path: "/product-content-downloader/:orderId/:oTP",
    name: "GuestProductContentDownloader",
    component: WebsiteGuestProductContentDownloaderView,
    props: true,
    meta: {
      layout: WebsiteLayout,
      gtm: "WebsiteGuestProductContentDownloader",
    },
  },
  // {
  //   path: "/prices",
  //   name: "WebsitePrices",
  //   component: WebsitePricesView,
  //   meta: { layout: WebsiteLayout, gtm: "WebsitePrices" },
  // },
  // {
  //   path: "/how-it-works",
  //   name: "WebsiteHowItWorks",
  //   component: WebsiteHowItWorksView,
  //   meta: { layout: WebsiteLayout },
  // },
  {
    path: "/meet-the-team",
    name: "WebsiteMeetTheTeam",
    component: WebsiteMeetTheTeamView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteMeetTheTeam" },
  },
  // {
  //   path: '/developer-test',
  //   name: 'DevTest',
  //   component: DevTestView,
  //   meta: { layout: WebsiteLayout }
  // },
  {
    path: "/retrieveusername",
    name: "RetrieveUsername",
    component: RetrieveUsername,
    meta: { layout: WebsiteLayout, gtm: "RetrieveUsername" },
  },
  {
    path: "/retrieveuserlogin",
    name: "RetrieveUserLogin",
    component: RetrieveUserLogin,
    meta: { layout: WebsiteLayout, gtm: "RetrieveUserLogin" },
  },
  {
    path: "/login/:email/:password",
    name: "RetrieveUserLoginPassword",
    component: RetrievedUserLogin,
    meta: { layout: WebsiteLayout, gtm: "RetrieveUserLoginPassword" },
  },
  {
    path: "/auth",
    name: "Authenticator",
    component: Authenticator,
    meta: { layout: WebsiteLayout, gtm: "Authenticator" },
  },
  {
    path: "*",
    name: "NotFound",
    component: PageNotFoundView,
    meta: { layout: WebsiteLayout, gtm: "NotFound" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // Redirect root to default category
  // if (to.path === "/") {
  //   return next("/category/fdf23d39-00d1-4456-831d-e288e8961a3f");
  // }
  // if (to.path === "/app/products") {
  //   return next("/app/products/category/fdf23d39-00d1-4456-831d-e288e8961a3f");
  // }

  store.dispatch("fetchAppConfig", "maintenance");

  // Disable GTM tracking for routes with noTrack: true
  if (to.meta.noTrack) {
    Vue.gtm.enable(false); // Disable all GTM activity
  } else {
    Vue.gtm.enable(true); // Re-enable GTM for other routes
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // Define routes that 'admin' and 'superadmin' should not access
  const restrictedRoutes = [
    "",
    "/product/*",
    "/category/:categoryId*",
    "/app/products/category/:categoryId*",
    "/app/products/:productId/:action*",
    "/app/products/:productId*",
    "/app/bought-products/category/:categoryId*",
    "/app/bought-products",
  ];

  let currentAuthenticatedUser = null;

  // Check for restricted public routes for admin/superadmin
  if (!requiresAuth) {
    try {
      currentAuthenticatedUser = await Auth.currentAuthenticatedUser().catch(
        (error) => {
          console.log("error:", error);
        },
      );

      if (currentAuthenticatedUser) {
        const idToken = currentAuthenticatedUser.signInUserSession.getIdToken();
        const userGroups = idToken.payload["cognito:groups"] || [];

        // Update store with user groups
        store.commit("storeUserGroups", userGroups);
        if (!store.state.userSignedIn) {
          store.commit("storeUserSignedIn", true);
          store.commit(
            "storeUserEmail",
            currentAuthenticatedUser.attributes.email,
          );
        }

        // Redirect admin/superadmin to /admin/productorders if accessing restricted public routes
        if (
          (userGroups.includes("admin") || userGroups.includes("superadmin")) &&
          restrictedRoutes.some((path) =>
            to.matched.some((record) => record.path === path),
          )
        ) {
          return next("/admin/productorders");
        }
      } else {
        // Clear store if no user is authenticated
        if (store.state.userSignedIn) {
          store.commit("storeUserSignedIn", false);
          store.commit("storeUserEmail", "");
        }
      }
      return next();
    } catch (error) {
      console.log("error:", error);
      return next();
    }
  }

  // Existing logic for authenticated routes
  currentAuthenticatedUser = await Auth.currentAuthenticatedUser().catch(
    (error) => {
      console.log("error:", error);
    },
  );

  if (!currentAuthenticatedUser) {
    return next({
      path: "/auth",
      query: { redirect: to.fullPath },
    });
  }

  try {
    let userGroups = [];

    if (Array.isArray(store.state.userGroups)) {
      userGroups = store.state.userGroups;
    } else {
      let idToken = currentAuthenticatedUser.signInUserSession.getIdToken();
      let groups = idToken.payload["cognito:groups"] || [];

      if (!groups.includes("teacher")) {
        currentAuthenticatedUser = await Auth.currentAuthenticatedUser({
          bypassCache: true,
        }).catch((error) => {
          console.log("error:", error);
        });

        idToken = currentAuthenticatedUser.signInUserSession.getIdToken();
        groups = idToken.payload["cognito:groups"] || [];
      }

      if (currentAuthenticatedUser) {
        if (!store.state.userSignedIn) {
          store.commit("storeUserSignedIn", true);
          store.commit(
            "storeUserEmail",
            currentAuthenticatedUser.attributes.email,
          );
        }
      } else {
        if (store.state.userSignedIn) {
          store.commit("storeUserSignedIn", false);
          store.commit("storeUserEmail", "");
        }
      }

      userGroups = groups;
      store.commit("storeUserGroups", groups);
    }

    // Existing authorization check
    const allowedGroups = to.meta.allowedGroups || [];

    // Check if admin/superadmin is trying to access a teacher-only route or restricted authenticated route
    if (
      (userGroups.includes("admin") || userGroups.includes("superadmin")) &&
      ((allowedGroups.length === 1 && allowedGroups[0] === "teacher") ||
        restrictedRoutes.some((path) =>
          to.matched.some((record) => record.path === path),
        ))
    ) {
      return next("/admin/productorders");
    }

    if (
      allowedGroups.length === 0 ||
      userGroups.some((group) => allowedGroups.includes(group))
    ) {
      return next();
    } else {
      return next({
        path: "/unauthorised",
      });
    }
  } catch (error) {
    console.log("error:", error);
    return next({
      path: "/auth",
      query: { redirect: to.fullPath },
    });
  }
});

// router.afterEach((to) => {
//   if (window.fbq && !to.path.includes("/admin")) {
//     // eslint-disable-next-line
//     fbq("track", "PageView"); // Re-track on non-admin route changes
//     // console.log('Re-tracking Facebook Pixel on route change to', to.fullPath);
//   } else {
//     // console.log('Skipping Facebook Pixel tracking for admin route', to.fullPath);
//   }
//   console.log("Route changed to:", to, adminRouteNames);
// });

import VueGtm from "@gtm-support/vue2-gtm";

const adminRouteNames = routes
  .filter(
    (route) =>
      route.path?.startsWith("/admin") && route.meta?.noTrack !== false,
  )
  .map((route) => route.name);

Vue.use(VueGtm, {
  id: [
    "GTM-TGFRHN72",
    // , "G-4JPZRSY7H4", "GT-TXZC2NLG"
  ], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  queryParams: {
    // // Add url query string when load gtm.js with GTM ID (optional)
    // gtm_auth: 'xxx',
    // gtm_cookies_win: 'x'
  },
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: adminRouteNames, // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

export default router;
